import Vue from 'vue'
import Router from 'vue-router'
import Assist from './Assist'
import Index from './course/Index'
import Center from './personal/Center'
Vue.use(Router)


const ROUTES = [
  // Default route
  { path: '', redirect: '/Index' }
]
  const routes = ROUTES.concat(Assist,Index,Center);

  //获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})
 
export default router



// WEBPACK FOOTER //
// ./src/router/index.js